import { chatbotActionButton } from '../../components/action-buttons/action-buttons.consts';
import { ButtonColor } from '../../components/action-buttons/action-buttons.types';
import { ActionButtonBase } from '../../directives/action-buttons-base.directive';

/** User-settings key the column configuration is saved under. */
export const CARRIERS_COLUMN_LIST = 'column_list-carriers';

/** Form key the plant's allowed fields are read under. */
export const CARRIERS_FIELDS_KEY = 'CARRIERS_MODULE_FORMKEY';

/** Namespace the column captions are translated from, by field name. */
export const CARRIERS_COLUMN_LABEL_PREFIX = 'defaultFields.carriers-module.';

/** Kept so a second click reuses the dialog rather than opening another. */
export const CARRIERS_COLUMNS_DIALOG_ID = 'carriers-select-columns-dialog';

export const CARRIERS_TEST_IDS = {
  columnSelect: 'carriers-column-select',
} as const;

export enum CarriersActionName {
  ADD = 'ADD',
  CHATBOT = 'CHATBOT',
}

export type CarriersActionButton = ActionButtonBase<CarriersActionName> & {
  tooltipKey: string;
  visibilityRule?: 'carriersCreate';
};

export const carriersActionButtons: CarriersActionButton[] = [
  {
    color: ButtonColor.Red,
    icon: 'add',
    name: CarriersActionName.ADD,
    tooltipKey: 'carriersList.add',
    visibilityRule: 'carriersCreate',
  },
  chatbotActionButton(CarriersActionName.CHATBOT),
];
